import axios from './axios';

export function fetchCheckoutConfig() {
  return axios.get('/config');
}

export function createPayment(payload) {
  return axios.post('/payments', payload);
}

export function getPayment(gatewayOrderNo, sync = true) {
  return axios.get(`/payments/${encodeURIComponent(gatewayOrderNo)}`, {
    params: { sync: sync ? 'true' : 'false' },
  });
}
